import React from "react";
import useSeo from "@/hooks/useSeo";
import { breadcrumbSchema } from "@/lib/schema";

export function PrivacyPage() {
  useSeo({
    title: "Privacy Policy — SSK Enterprises",
    description: "SSK Enterprises privacy policy — how we collect, use and protect the information you share via our enquiry forms.",
    path: "/privacy",
    jsonLd: [breadcrumbSchema([{ name: "Home", path: "/" }, { name: "Privacy Policy", path: "/privacy" }])],
  });
  return (
    <section className="section">
      <div className="container-x max-w-3xl">
        <div className="overline">Legal</div>
        <h1 className="font-display text-4xl font-black mt-2">Privacy Policy</h1>
        <div className="mt-6 space-y-4 text-slate-700 leading-relaxed">
          <p>SSK Enterprises respects your privacy. We collect only the information you voluntarily provide through our enquiry forms (name, company, contact details, product requirement).</p>
          <p>This information is used solely to respond to your enquiry, share quotations, and provide product support. We do not sell or share your data with third parties except as required to fulfil your enquiry.</p>
          <p>For any privacy-related concerns, please contact us via the details on our Contact page.</p>
        </div>
      </div>
    </section>
  );
}

export function TermsPage() {
  useSeo({
    title: "Terms & Conditions — SSK Enterprises",
    description: "Terms of use governing product information, imagery, trademarks and distributor status on the SSK Enterprises website.",
    path: "/terms",
    jsonLd: [breadcrumbSchema([{ name: "Home", path: "/" }, { name: "Terms & Conditions", path: "/terms" }])],
  });
  return (
    <section className="section">
      <div className="container-x max-w-3xl">
        <div className="overline">Legal</div>
        <h1 className="font-display text-4xl font-black mt-2">Terms &amp; Conditions</h1>
        <div className="mt-6 space-y-4 text-slate-700 leading-relaxed">
          <p>All product information on this website is provided for reference. Actual specifications, packaging availability and technical data must be confirmed at the time of quotation.</p>
          <p>Product images may be illustrative. Trademarks (MR Chemie, 3AK Chemie, KLYDE, NTN and others) are the property of their respective owners.</p>
          <p>SSK Enterprises acts as an Authorised Distributor of 3AK Chemie Pvt. Ltd. Supply of other brands (including NTN) is subject to availability and customer requirement.</p>
        </div>
      </div>
    </section>
  );
}
